/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BrowserService {
  isMobile = false;
  isChrome = false;
  isLexmark = false;
  ua = navigator.userAgent;

  constructor() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
        this.ua,
      )
    ) {
      this.isMobile = true;
    }

    if (/Chrome/i.test(this.ua)) {
      this.isChrome = true;
    }

    if (/lexmarkwebclient/i.test(this.ua)) {
      this.isLexmark = true;
    }
  }

  browserType(): number {
    let browserType = 0;
    let uaString = navigator.userAgent || '';
    uaString = uaString.toLowerCase();
    if (uaString.indexOf('galio') >= 0) {
      browserType = 1;
    } else if (uaString.indexOf('webkit') >= 0) {
      if (uaString.indexOf('x2g') >= 0) {
        browserType = 2;
      } else if (uaString.indexOf('x3g') >= 0) {
        browserType = 3;
      } else if (uaString.indexOf('lexmarkwebclient') >= 0) {
        browserType = 3;
      }
    }
    return browserType;
  }
}
